import { Box } from "@mui/material";
import React from "react";

import { ApiStructuredContent } from "../../../api/chats.api";
import { AnswerDebugDetail } from "../AnswerDebug";
import { ChatAvatar } from "../primitives/ChatAvatar";
import { MessageBubble } from "../primitives/MessageBubble";
import { StructuredContentRenderer } from "../StructuredContentRenderer";

interface AssistantMessageProps {
  structuredContent?: ApiStructuredContent;
  debug?: any;
}

const AssistantMessageComponent: React.FC<AssistantMessageProps> = ({
  structuredContent,
  debug,
}) => (
  <Box>
    <MessageBubble variant="assistant" avatar={<ChatAvatar variant="assistant" />}>
      <StructuredContentRenderer structuredContent={structuredContent} />
    </MessageBubble>
    {debug && <AnswerDebugDetail debugValue={debug} />}
  </Box>
);

export const AssistantMessage = React.memo(AssistantMessageComponent);
